import { Link, Typography } from '@mui/material';
import { useAppNavigation } from 'contexts/navigation';
import { useProjectId } from 'store/project';
import { ReactElement, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  DocumentationViewItem,
  DocumentationViewItemType,
  isDirectoryItemType,
} from 'store/documentation/model/types';

const NO_SOURCE_ISSUE = '–';

interface Props {
  rowData: DocumentationViewItem;
}

export function DocumentationExportedFromIssueCell({
  rowData,
}: Props): ReactElement | null {
  const projectId = useProjectId();
  const location = useLocation();
  const { goToIssueDetails } = useAppNavigation();

  const fileRow = rowData as DocumentationViewItem & {
    type: DocumentationViewItemType.FILE;
    sourceIssue?: { issueId?: string; issueNumber?: string };
  };

  const sourceIssueId = fileRow.sourceIssue?.issueId;
  const sourceIssueNumber = fileRow.sourceIssue?.issueNumber;

  const hasSourceIssue = Boolean(
    projectId && sourceIssueId && sourceIssueNumber
  );

  const handleNavigate = useCallback((): void => {
    if (!projectId || !sourceIssueId) return;
    const returnUrl = `${location.pathname}${location.search}`;
    goToIssueDetails(projectId, sourceIssueId, {
      state: { returnUrl },
    });
  }, [
    location.pathname,
    location.search,
    projectId,
    sourceIssueId,
    goToIssueDetails,
  ]);

  if (isDirectoryItemType(rowData.type)) {
    return null;
  }

  if (!hasSourceIssue || !sourceIssueNumber) {
    return <Typography variant='body2'>{NO_SOURCE_ISSUE}</Typography>;
  }

  return (
    <Link
      component='button'
      type='button'
      variant='body2'
      underline='none'
      onClick={handleNavigate}
      sx={{
        textAlign: 'left',
        color: 'text.primary',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      {sourceIssueNumber}
    </Link>
  );
}
